document.addEventListener('DOMContentLoaded', function() {
  let carouselCount = 0; // Counter to ensure unique IDs

  function replaceProductShortcodes() {
    const blogContent = document.querySelectorAll('.rte');
    blogContent.forEach((content) => {
      // Updated regex to capture optional attributes: top_padding, bottom_padding, button_text
      const regex = /\[product\s+handle="([\w\-,]+)"(?:\s+top_padding="(\d+)")?(?:\s+bottom_padding="(\d+)")?(?:\s+button_text="([^"]*)")?(?:\s+learn_more="(true)")?\s*\]/g;
      let matches;
      // We need to collect all matches first, then replace — to avoid issues with innerHTML changing mid-loop
      const matchList = [];
      while ((matches = regex.exec(content.innerHTML)) !== null) {
        matchList.push({
          fullMatch: matches[0],
          handles: matches[1].split(',').map(handle => handle.trim()),
          topPadding: matches[2] || '0',
          bottomPadding: matches[3] || '0',
          buttonText: matches[4] || 'Add to Cart',
          learnMore: matches[5] === 'true'
        });
      }

      matchList.forEach((match) => {
        const { fullMatch, handles, topPadding, bottomPadding, buttonText, learnMore } = match;

        console.log('Extracted product handles:', handles);

        if (handles.length === 0 || handles[0] === '') {
          console.error('No valid product handles found in the shortcode.');
          return; // Skip
        }

        // Increment carousel count to ensure unique ID
        const carouselID = `owl-carousel-${carouselCount++}`;

        // Fetch the product data and pass the carousel ID
        fetchProductsData(handles, content, carouselID, fullMatch, topPadding, bottomPadding, buttonText, learnMore);
      });
    });
  }

  function fetchProductsData(productHandles, content, carouselID, originalShortcode, topPadding, bottomPadding, buttonText, learnMore) {
    // Use Promise.allSettled so archived/unavailable products don't break the whole carousel
    const productPromises = productHandles.map(handle => {
      if (!handle) {
        console.error('Empty product handle provided.');
        return Promise.reject(new Error('Empty handle'));
      }
      return fetch(`/products/${handle}.js`).then(response => {
        if (!response.ok) {
          console.warn(`Product not found or archived for handle: "${handle}" — skipping.`);
          throw new Error('Product not found');
        }
        return response.json();
      });
    });

    Promise.allSettled(productPromises)
      .then(results => {
        // Filter to only fulfilled (available) products
        const products = results
          .filter(result => result.status === 'fulfilled')
          .map(result => result.value);

        if (products.length === 0) {
          console.warn('No available products found for shortcode — removing shortcode from content.');
          content.innerHTML = content.innerHTML.replace(originalShortcode, '');
          return;
        }

        // Build carousel HTML
        const carouselHTML = products.map(product => `
          <div class="article" style="text-align: center;margin-left:10px;">
            <div class="figure">
              <a id="product-shortcode-carousel" href="${product.url}"><img src="${product.images[0]}" alt="${product.title}"></a>
            </div>
            <div class="aside">
              <h6 class="shortcode"><a id="product-shortcode-carousel" class="shortcode" href="${product.url}">${product.title.length > 55 ? product.title.substring(0, 55) + '...' : product.title}
</a></h6>
              <p class="price">$${(product.price / 100).toFixed(2)}</p>
              ${learnMore
                ? `<a href="${product.url}" class="read-more-shortcode">${buttonText === 'Add to Cart' ? 'Learn More' : buttonText}</a>`
                : `<button id="product-shortcode-carousel" class="add-to-cart read-more-shortcode" data-id="${product.variants[0].id}">${buttonText}</button>`
              }
            </div>
          </div>
        `).join('');

        // Wrap the carousel HTML with a unique ID and padding
        const carouselWrapper = `
          <div id="${carouselID}" class="owl-carousel product-slider2 product-slider-blog" style="padding-top: ${topPadding}px; padding-bottom: ${bottomPadding}px;">
            ${carouselHTML}
          </div>
        `;

        // Replace the shortcode with the carousel
        content.innerHTML = content.innerHTML.replace(originalShortcode, carouselWrapper);

        // Initialize Owl Carousel after adding HTML for this specific carousel
        initializeOwlCarousel(`#${carouselID}`, products.length);
      })
      .catch(error => {
        console.error("Error fetching product data:", error);
      });
  }

  // Initialize Owl Carousel for a specific carousel
  function initializeOwlCarousel(carouselSelector, productCount) {
    // Wait for a short period to ensure the carousel is rendered in the DOM
    setTimeout(() => {
      $('.owl-carousel').on('initialized.owl.carousel changed.owl.carousel', function(event) {
        $('.owl-prev').removeClass('disabled');
        $('.owl-next').removeClass('disabled');
      });
      $(carouselSelector).owlCarousel({
        loop: false,
        margin: 16,
        nav: false,
        onTranslated: function(event) {
            $(".owl-next, .owl-prev").removeClass("disabled");
        },
        dots: true,
        autoplay: false,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        responsive:{
          0:{
            autoWidth: true,
          },
          768:{
            items: 3,
            margin: 24,
            nav: true,
            dots: false,
          },
          992:{
            items: 3,
            margin: 24,
            nav: true,
            dots: false,
          },
          1200:{
            items: 4,
            margin: 15,
            nav: true,
            dots: false,
          }
        }
      });

      if (productCount <= 3) {
        const carouselEl = document.querySelector(carouselSelector);
        if (carouselEl) {
          carouselEl.classList.add('product-carousel-centered');
          const owlStage = carouselEl.querySelector('.owl-stage');
          if (owlStage) {
            owlStage.style.display = 'flex';
            owlStage.style.justifyContent = 'center';
          }
        }
      }
    }, 500);
  }

  (function injectCenteringStyles() {
    const style = document.createElement('style');
    style.textContent = `
      .product-carousel-centered .owl-stage {
        display: flex;
        justify-content: center;
        margin: auto;
      }
    `;
    document.head.appendChild(style);
  })();

  // Event listener using event delegation to handle dynamic buttons
  document.body.addEventListener('click', function(event) {
    if (event.target.classList.contains('add-to-cart')) {
      const variantId = event.target.getAttribute('data-id');
      if (variantId) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        })
        .then(response => response.json())
        .then(data => {
          console.log('Add to Cart response:', data);
        })
        .catch(error => {
          alert('Failed to add product to cart.');
          console.error('Error adding product to cart:', error);
        });
      }
    }
  });

  replaceProductShortcodes();
});